export default __webpack_public_path__ + "static/media/PDR-1.3b9fd77c.jpg";